module.exports = __webpack_public_path__ + "img/test_top1.f38d81ca.jpg";